import { PAGE_SIZE } from '../../../constants/Config';
import {
    USER_SERVICE_DELETE,
    USER_SERVICE_DETAIL,
    USER_SERVICE_INSERT,
    USER_SERVICE_LIST,
    USER_SERVICE_UPDATE,
    USER_SERVICE_GET_ALL,
    USER_SERVICE_SELECT,
    USER_SERVICE_USER_LIST,
    USER_SERVICE_LIST_RESET,
    USER_SERVICE_TIMESHIFT,
    USER_SERVICE_SERVICE_LIST,
    USER_SERVICE_GET_BY_USER_ID
} from './action-types';

const initialState = {
    data: [],
    totalRows: 0,
    currentPage: 0,
    pageSize: PAGE_SIZE,
    item: null,
    selectedService: null,
    suggestion: null,
    timeshift: [],
    serviceList: [],
    serviceTotalRows: 0,
    serviceByUser: []
};

const reducer = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case USER_SERVICE_TIMESHIFT:
            return timeshift(state, payload);
        case USER_SERVICE_SELECT:
            return select(state, payload);
        case USER_SERVICE_LIST:
            return list(state, payload);
        case USER_SERVICE_SERVICE_LIST:
            return serviceList(state, payload);
        case USER_SERVICE_DETAIL:
            return detail(state, payload);
        case USER_SERVICE_UPDATE:
            return update(state, payload);
        case USER_SERVICE_INSERT:
            return insert(state, payload);
        case USER_SERVICE_DELETE:
            return deletes(state, payload);
        case USER_SERVICE_LIST_RESET:
            return resetList(state);
        case USER_SERVICE_GET_ALL:
            return getAll(state, payload);
        case USER_SERVICE_USER_LIST:
            return getAllUser(state, payload);
        case USER_SERVICE_GET_BY_USER_ID:
            return getAllServiceByUser(state, payload);
        default:
            return state;
    }
};

function timeshift(state, payload) {
    state = Object.assign({}, state, {
        timeshift: payload
    });
    return state;
}

function resetList(state) {
    state = Object.assign({}, state, {
        data: null
    });
    return state;
}

function select(state, payload) {
    state = Object.assign({}, state, {
        selectedService: payload
    });
    return state;
}

function list(state, payload) {
    return { ...state, ...payload };
}

function serviceList(state, payload) {
    return { ...state, serviceList: payload.data, serviceTotalRows: payload.totalRows };
}

function detail(state, payload) {
    state = Object.assign({}, state, {
        item: payload
    });
    return state;
}

function deletes(state, payload) {
    const data = state.data.filter(obj => obj.UserId !== payload);

    return Object.assign({}, state, { data });
}

function update(state, payload) {
    const data = state.data.map(obj => {
        if (obj.id === payload.id) {
            return { ...obj, ...payload };
        }
        return obj;
    });

    return Object.assign({}, state, { data });
}

function insert(state, payload) {
    const data = [...state.data, payload];
    return Object.assign({}, state, {
        data
    });
}

function getAll(state, payload) {
    state = Object.assign({}, state, {
        suggestion: payload
    });
    return state;
}

function getAllUser(state, payload) {
    state = Object.assign({}, state, {
        usersList: payload
    });
    return state;
}

const getAllServiceByUser = (state, payload) => {
    state = Object.assign({}, state, {
        serviceByUser: payload
    });
    return state;
};

export const getUserServicesList = state => state.userService.data;
export const getServicesByUserList = state => state.userService.serviceList;

export default reducer;
